const company = {
  title: "تفاصيل الشركة",
  description:
    "أخبرنا المزيد لإنشاء ملف تعريف شركتك من خلال تقديم المعلومات أدناه.",
  enName: {
    label: "اسم الشركة بالإنجليزية",
    placeholder: "مثال: Proline Global",
  },
  arName: {
    label: "اسم الشركة بالعربية",
    placeholder: "اسم الشركة باللغة العربية",
  },
  city: {
    label: "المدينة المسجلة",
    placeholder: "اختر المدينة",
  },
  commercialRecord: {
    label: "السجل التجاري",
    placeholder: "12345-67890",
  },
  logo: {
    shortLabel: "الشعار",
    label: "شعار الشركة",
    hint: "SVG أو PNG أو JPG أو GIF (بحد أقصى 800×400 بكسل)",
  },
  uploadFile: {
    label: "رفع مستند السجل التجاري",
    clickToUpload: "انقر للرفع",
    dragHint: "أو اسحب الملف وأفلته هنا",
    hint: "ملف PDF واحد فقط.",
    uploading: "جاري الرفع",
  },
  delegationDocumentUrl: {
    label: "رفع مستند التفويض",
    clickToUpload: "انقر للرفع",
    dragHint: "أو اسحب الملف وأفلته هنا",
    hint: "PDF فقط — بحد أقصى 5 ميجابايت (ملف واحد).",
  },
  personalIdUrl: {
    label: "رفع مستند الهوية",
    clickToUpload: "انقر للرفع",
    dragHint: "أو اسحب الملف وأفلته هنا",
    hint: "PDF أو JPG أو PNG — بحد أقصى 5 ميجابايت (ملف واحد).",
  },
  actions: {
    createCompany: "إنشاء الشركة",
  },
};

export default company;
